import type { ReportFileDto } from "@/api/dtos";
import type { ReportFile } from "@/api/report/_models/Report";

/** DTO → domain for a report file listing entry. */
export const toReportFileFromDto = (dto: ReportFileDto): ReportFile => {
  return {
    name: dto.name,
    type: dto.type,
    size: dto.size,
    modified: dto.modified,
  };
};
